import React from 'react';
import './LogosBar.css';

const technologies = [
    { name: 'Flutter', icon: 'iconsite/flutter-svgrepo-com.svg' },
    { name: 'Dart', icon: 'iconsite/dart-svgrepo-com.svg' },
    { name: 'React', icon: 'iconsite/react-javascript-js-framework-facebook-svgrepo-com.svg' },
    { name: 'TypeScript', icon: 'iconsite/typescript-official-svgrepo-com.svg' },
    { name: 'Python', icon: 'iconsite/python-svgrepo-com.svg' },
    { name: 'PHP', icon: 'iconsite/php-svgrepo-com.svg' },
    { name: 'MySQL', icon: 'iconsite/mysql-svgrepo-com.svg' },
    { name: 'Nginx', icon: 'iconsite/nginx-svgrepo-com.svg' },
    { name: 'Docker', icon: 'iconsite/docker-svgrepo-com.svg' },
    { name: 'Node.js', icon: 'iconsite/node-js-svgrepo-com.svg' },
    { name: 'Linux', icon: 'iconsite/linux-svgrepo-com.svg' }
];

function LogosBar() {
    return (
        <div className="logos-bar">
            <p>Технологии которые мы используем</p>
            <div className="logos-track">
                {technologies.map((tech, index) => (
                    <div className="logo-tech" key={index}>
                        <img src={tech.icon} alt={tech.name} width="28" height="28" />
                        <span>{tech.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LogosBar;